import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  FormHelperText,
  Input,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { report_job_or_post } from "../../DAL/general-apis/general-apis";
import { enqueueSnackbar } from "notistack";
import { upload_image_documents_on_s3 } from "../../DAL/jobs/jobs";
import { useIds } from "../../hook/AdminContext";

export default function ReportPage({
  report_to = "Post",
  targetId = "",
  closeModal = () => { },
  callBackFunction = () => { },
}) {
  const params = useParams();
  const { setBreadCrumb } = useIds();

  // const navigate = useNavigate();
  // const { state } = useLocation();
  // const returnPath = state?.backURL || null;

  // const report_to = params.report_to === "post" ? "Post" : "Job";

  const [loading, setLoading] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [comments, setComments] = useState("");
  const [image, setImage] = useState([]);

  const reasonsList = [
    {
      label: "Spam/Scam",
      value: "Spam/Scam",
    },
    {
      label: "Harassment",
      value: "Harassment",
    },
    {
      label: "Hate Speech",
      value: "Hate Speech",
    },
    {
      label: "Nudity",
      value: "Nudity",
    },
    {
      label: "Violence",
      value: "Violence",
    },
    {
      label: "False Information",
      value: "False Information",
    },
    {
      label: "Inappropriate content",
      value: "Inappropriate content",
    },
    {
      label: "Other",
      value: "Other",
    },
  ];

  const handleCheckboxChange = (value) => {
    setSelectedReason((prev) => (prev === value ? "" : value));
  };
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setImage((prev) => [...prev, ...files]); // Add new files to existing array
  };

  const handleRemoveImage = (index) => {
    setImage((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedReason) {
      enqueueSnackbar("Please select one reason before submitting.", {
        variant: "error",
      });
      return;
    }

    setLoading(true);
    let image_paths = []; // will store all uploaded image paths

    if (image?.length) {
      try {
        // Map each file to a Promise that uploads it
        const uploadPromises = image.map((file) => {
          const formData = new FormData();
          formData.append("image", file);
          return upload_image_documents_on_s3(formData);
        });

        // Wait for all uploads to complete
        const results = await Promise.all(uploadPromises);

        // Check results and collect paths
        results.forEach((res) => {
          if (res.code === 200 && res.image_path) {
            image_paths.push(res.image_path);
          } else {
            enqueueSnackbar(`Failed to upload one of the images.`, {
              variant: "error",
            });
            return;
          }
        });
      } catch (error) {
        console.error("Error uploading images:", error);
        enqueueSnackbar(`Failed to upload images.`, { variant: "error" });
        return;
      }
    }

    const postData = {
      reference: "",
      reason: selectedReason,
      report_against:
        report_to == "Post"
          ? "feed"
          : report_to == "insight"
            ? "blog"
            : report_to,
      comments: comments,
      file: image_paths,
    };

    if (report_to == "Post") {
      // postData.feed = params._id;
      postData.feed = targetId;
    } else if (report_to == "job") {
      // postData.job = params._id;
      postData.job = targetId;
    } else if (report_to == "insight") {
      postData.blog = targetId;
    } else if (report_to == "feed_comment") {
      postData.feed_comment = targetId;
    }

    const resp = await report_job_or_post(postData);
    if (resp.code == 200) {
      enqueueSnackbar(resp.message, { variant: "success" });
      // navigate(handleGetBackPath());
      callBackFunction(targetId);
      closeModal();
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  // const handleGetBackPath = () => {
  //   if (returnPath) {
  //     return returnPath;
  //   } else if (params.home_slug == "home") {
  //     return "/home";
  //   } else {
  //     return `/${params.home_slug}/home`;
  //   }
  // };
  // useEffect(() => {
  //   setBreadCrumb([
  //     {
  //       name: `Report ${report_to}`,
  //       path: `${handleGetBackPath()}`,
  //       active: false,
  //     },
  //     {
  //       name: `Report ${report_to}`,
  //       path: ``,
  //       active: false,
  //     },
  //   ]);
  // }, []);

  return (
    <div className="container-fluid mt-3">
      <div className="row mt-0">
        {/* <div className="col-12 heading-main">
          <h2>Report {report_to}</h2>
        </div> */}
        <div className="col-12">
          <div className="report-container">
            <h6>Reason for reporting the content</h6>
            <p>(Please select one reason)</p>
            <p className="description">
              Here you can specify the reason for your report and explain the
              legal grounds of your complaint. If the specific reason for your
              report is not listed in our given options, please select the
              option "Other" and explain your specific case in detail in the
              free text field provided.
            </p>

            <form onSubmit={handleSubmit} className="report-form">
              <FormGroup sx={{ mb: 3 }}>
                {reasonsList.map((reason, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        checked={selectedReason === reason.value}
                        onChange={() => handleCheckboxChange(reason.value)}
                      />
                    }
                    label={reason.label}
                  />
                ))}
              </FormGroup>

              <TextField
                label="Comments"
                variant="outlined"
                fullWidth
                multiline
                minRows={4}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                sx={{ mb: 3 }}
                required={selectedReason === "Other"} // only required for "Other"
              />

              <div className="row w-100 div-style ms-0 pt-0 align-items-center">
                {/* Label + Button on one row */}
                <div className="col-12 d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <label className="label-style mb-1 mt-0">
                      Upload Images
                    </label>
                    <FormHelperText
                      className="pt-0 text-muted"
                      sx={{ fontSize: "0.875rem" }}
                    >
                      Supported formats: JPG, JPEG, PNG, WEBP
                    </FormHelperText>
                  </div>

                  <label htmlFor="upload-button">
                    <input
                      className="d-none"
                      accept="image/jpeg, image/jpg, image/png, image/webp"
                      id="upload-button"
                      multiple
                      type="file"
                      name="image"
                      onChange={handleFileChange}
                    />
                    <button
                      className="outlined-btn mt-3 mt-md-0"
                      type="button"
                      onClick={() => {
                        document.getElementById("upload-button")?.click();
                      }}
                    >
                      <FileUploadIcon
                        className="me-2"
                        style={{ color: "var(--portal-primary-color)" }}
                      />
                      Upload
                    </button>
                  </label>
                </div>

                {/* Uploaded Images in a single line */}
                <div className="col-12 d-flex flex-wrap gap-2">
                  {image?.map((img, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      }}
                    >
                      <img
                        src={URL.createObjectURL(img)}
                        alt={`Preview ${index}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />

                      <IconButton
                        size="small"
                        onClick={() => handleRemoveImage(index)}
                        sx={{
                          position: "absolute",
                          top: "4px",
                          right: "4px",
                          backgroundColor: "rgba(255,255,255,0.9)",
                          "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                          "&:focus": { backgroundColor: "rgba(255,255,255,1)" },
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                      >
                        <CloseIcon
                          fontSize="small"
                          sx={{ color: "var(--error-color)" }}
                        />
                      </IconButton>
                    </div>
                  ))}
                </div>
              </div>

              <Divider className="my-3" />

              <div className="text-end">
                <button
                  type="submit"
                  className="btn-contained"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Report"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
